<template>
  <div>
    <div class="is-flex is-align-items-center is-justify-content-center" style="margin-bottom: 20px;">
      <related-position-adder @input="followPosition($event)" :payload="{ position_id: payload.position.id }" :filter_related_resources="related_resources"
                              :pick_with_server_call="false" :pick_and_close="false" statuses="active,editing,expired">
      </related-position-adder>
      <router-link :to="{ name: 'related-offers', query: { position_id: payload.position.id, company_id: payload.position.company.resource_id } }"
                   class="absolute button is-info" style="right: 30;">
        Offers
      </router-link>
    </div>
    <div class="is-flex is-align-items-center is-justify-content-space-between" style="height: 500px; overflow-y: hidden; border: 3px solid rgba(0, 0, 0, 0.2);">
      <div style="height: 100%; width: 100%;">
        <div style="text-align: center; border-bottom: 3px solid rgba(0, 0, 0, 0.1);">
          <p class="bold">המשרה עוקבת אחרי</p>
        </div>
        <div style="overflow-y: auto; height: 100%;" class="is-flex is-justify-content-center">
          <div v-if="is_loading" class="is-flex is-align-items-center">
            <div class="loading"></div>
          </div>
          <div v-else style="width: 90%;">
            <div v-if="related_resources.length == 0" class="is-flex is-justify-content-center is-align-items-center">
              <p>אין תוצאות</p>
            </div>
            <related-resource v-for="related_resource in related_resources" @deleted="refresh"
                              :key="related_resource.id" :related_resource="related_resource" :show_divider="true" :flexed="true">
            </related-resource>
            <div v-if="related_resources.length > 0" style="height: 45px;"></div>
          </div>
        </div>
      </div>
      <div class="relative" style="height: 100%; width: 100%;">
        <div style="text-align: center; border-bottom: 3px solid rgba(0, 0, 0, 0.1);">
          <p class="bold">הצעות למשרות נוספות</p>
        </div>
        <div class="relative" style="border-right: 3px solid rgba(0, 0, 0, 0.1); height: 100%; width: 100%; overflow-y: auto;" >
          <div v-if="is_adding_position" class="is-flex is-justify-content-center is-align-items-center" style="height: 100%;">
            <div class="loading"></div>
          </div>
          <div v-else class="is-flex is-justify-content-center">
            <div style="width: 100%;">
              <div v-if="filteredSuggstedPositions.length == 0" class="is-flex is-justify-content-center is-align-items-center">
                <p>אין תוצאות</p>
              </div>
              <search-modal-positions @input="followPosition($event)" :results="filteredSuggstedPositions" :show_follow_button="true">
              </search-modal-positions>
              <div style="height: 45px;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import RelatedPositionAdder from '@/components/RelatedPositionAdder'
import RelatedResource from '@/components/RelatedResource'
import SearchModalPositions from '@/components/SearchModalPositions'
export default {
  name: 'related-positions-manager',
  props: ['payload'],
  data () {
    return {
      is_loading: true,
      is_adding_position: false,
      related_resources: [],
      suggestions_positions: [],
      similar_positions: []
    }
  },
  created () {
    this.init()
  },
  computed: {
    filteredSuggstedPositions () {
      let related_positions_ids = [...this.related_resources].map(related_position => related_position.leader.position.id)
      let filtered_suggestions = this.suggestions_positions.filter(suggested_position => !related_positions_ids.includes(suggested_position.id) && suggested_position.id != this.payload.position.id)
      let filtered_similar = this.similar_positions.filter(similar_position => !related_positions_ids.includes(similar_position.id) && similar_position.id != this.payload.position.id)
      return this.removeDuplicatesSuggestions([...filtered_suggestions, ...filtered_similar])
    }
  },
  methods: {
    removeDuplicatesSuggestions (suggested_positions) {
      return this.$utils.removeObjectArrayDuplicates(suggested_positions, 'id')
    },
    refresh () {
      this.suggestions_positions = []
      this.init()
    },
    init () {
      this.is_loading = true
      this.$network_utils.getRelatedResources({
        follower_type: 'Position',
        follower_id: this.payload.position.id,
        approval_statuses: 'true,NULL'
      }).then(response => {
        this.related_resources = response.sort((a, b) => {
          return b.leader.position.is_hot - a.leader.position.is_hot
        })
        this.getSuggestedPositions()
        this.getSimilarPositions()
        this.is_loading = false
      })
    },
    getSimilarPositions () {
      this.$network_utils.getAllPositions({
        similar_positions: this.payload.position.id,
        is_hot: 'true'
      }).then(response => {
        this.similar_positions = response
      })
    },
    getSuggestedPositions () {
      this.related_resources.forEach(related_resource => {
        this.$network_utils.getRelatedResources({
          follower_type: 'Position',
          follower_id: related_resource.leader.position.id,
          approval_statuses: 'true,NULL'
        }).then(response => {
          let positions = response.map(related_resource => related_resource.leader.position)
          this.suggestions_positions.push(...positions.sort((a, b) => {
            return b.is_hot - a.is_hot
          }))
        })
      })
    },
    async followPosition ({ id }) {
      this.is_adding_position = true
      const base = { leader_type: 'Position', follower_type: 'Position' }
      const { id: localId } = this.payload.position
      await this.$network_utils.createRelatedResource({ ...base, leader_id: id, follower_id: localId })
      await this.$network_utils.createRelatedResource({ ...base, leader_id: localId, follower_id: id })
      this.is_adding_position = false
      this.refresh()
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    RelatedPositionAdder,
    RelatedResource,
    SearchModalPositions
  }
}
</script>
